// Mock data for portfolio website

export const personalInfo = {
  name: "Tiago Cardoso",
  headline: "Arquiteto de soluções digitais e Vivo Creator com foco em resultados.",
  subheadline: "Transformo tecnologia em soluções práticas, eficientes e escaláveis para empresas, condomínios e pessoas que buscam performance, segurança e experiência digital.",
  badge: "Consultoria de tecnologia | Vivo Creator | Arquitetura de soluções digitais",
  badge2: "Mais de 15 anos de experiência em tecnologia",
  profileImage: "/profile.jpg",
  about: "Sou arquiteto de soluções digitais e consultor em tecnologia com mais de 15 anos de experiência. Atuo na interseção entre estratégia, conectividade, automação e experiência digital, ajudando empresas e projetos residenciais a transformar necessidades complexas em soluções claras, eficientes e escaláveis.\n\nMinha atuação combina visão técnica e prática de campo, incluindo arquitetura de integrações, evolução de jornadas digitais, redes Wi-Fi seguras e automação com IoT. Também sou criador de conteúdo tech, traduzindo temas de inovação, conectividade e soluções digitais para linguagem acessível nas redes.\n\nEstou baseado em São Paulo e atendo projetos em todo o Brasil com foco em valor percebido, operação estável e resultados mensuráveis."
};

export const aboutHighlights = [
  {
    title: "Especialidades",
    items: [
      "Arquitetura de soluções e integração de sistemas",
      "Conectividade corporativa e residencial (Wi-Fi, segmentação, segurança)",
      "Automação e IoT com foco em confiabilidade",
      "Evolução de jornadas digitais e experiência do cliente"
    ]
  },
  {
    title: "Setores atendidos",
    items: [
      "Empresas e times de tecnologia",
      "Condomínios e operações prediais",
      "Pequenos negócios e residências conectadas",
      "Marcas que buscam creator tech com credibilidade"
    ]
  }
];

export const workProcess = [
  {
    title: "Diagnóstico e objetivos",
    description: "Entendimento do contexto, dores e metas com foco em impacto real e priorização inteligente."
  },
  {
    title: "Desenho da solução",
    description: "Arquitetura técnica, definição de integrações e desenho de fluxos com foco em segurança e escalabilidade."
  },
  {
    title: "Implementação e acompanhamento",
    description: "Apoio na execução, validação e ajustes para garantir estabilidade, performance e adoção."
  }
];

export const vivoCreators = {
  title: "Vivo Creators",
  subtitle: "Embaixador da marca e criador de conteúdo",
  description: "Faço parte do Vivo Creators, iniciativa oficial da Vivo que reconhece colaboradores como embaixadores e influenciadores. Nas redes sociais, dou visibilidade a iniciativas e mensagens estratégicas da companhia com uma comunicação humana, clara e orientada a valor.\n\nComo Vivo Creator, produzo conteúdo com responsabilidade e utilidade, conectando tecnologia, conectividade, inovação e experiência digital a casos reais e aprendizados práticos que ajudam pessoas e empresas a tomar melhores decisões.",
  highlights: [
    "Embaixador da marca Vivo",
    "Conteúdo tech com visão prática",
    "Conectividade, redes e experiência digital",
    "Comunicação clara e didática"
  ]
};

export const experienceVivo = [
  {
    id: 1,
    title: "Produtos e jornadas B2C (Vivo Total)",
    description: "Participação em projetos B2C com impacto direto no dia a dia das pessoas, evoluindo produtos e jornadas digitais com foco em clareza, experiência e valor percebido.",
    icon: "smartphone"
  },
  {
    id: 2,
    title: "Evolução de canais digitais e jornadas",
    description: "Evolução de jornadas e funcionalidades para clientes empresariais, buscando consistência, eficiência operacional e uma experiência digital robusta.",
    icon: "briefcase"
  },
  {
    id: 3,
    title: "Arquitetura de soluções e integrações",
    description: "Desenho e alinhamento de soluções envolvendo integrações com plataformas corporativas e sistemas legados, garantindo rastreabilidade, estabilidade e escalabilidade.",
    icon: "network"
  },
  {
    id: 4,
    title: "Conectividade e experiência digital",
    description: "Atuação com temas de conectividade e soluções digitais (incluindo eSIM e experiências correlatas), conectando tecnologia ao uso real e às necessidades do cliente.",
    icon: "wifi"
  }
];
export const experiencePractice = [
  {
    id: 1,
    title: "Redes e conectividade (Wi-Fi, cabeamento e segmentação)",
    description:
      "Projeto e implantação de redes para residências, pequenos negócios e ambientes compartilhados, com foco em estabilidade e segurança. Planejo cobertura Wi-Fi, organizo infraestrutura (pontos, switches e cabeamento) e aplico segmentação por perfis (Visitantes/Colaboradores/IoT). Também realizo diagnóstico e correção de instabilidade — quedas, latência e saturação — priorizando custo-benefício e manutenção simples.",
    icon: "wifi"
  },
  {
    id: 2,
    title: "Automação residencial e comercial (IoT na prática)",
    description:
      "Automação aplicada ao mundo real para simplificar rotinas e aumentar conforto com confiabilidade. Integro dispositivos e cenários (iluminação, sensores, tomadas e alertas), crio automações por contexto (horários, presença e eventos) e padronizo o ambiente IoT para reduzir falhas e facilitar expansão futura, sempre com operação simples no dia a dia.",
    icon: "zap"
  },
  {
    id: 3,
    title: "Segurança eletrônica e controle de acesso",
    description:
      "Implantação e melhoria de soluções de segurança com visão de risco e continuidade. Desenvolvo projetos de CFTV (incluindo câmeras Wi-Fi) com estratégia de cobertura e acesso remoto, parametrizo controle de acesso/biometria e avalio tecnologias para portaria e monitoramento. Também apoio auditorias de configurações e processos, com recomendações práticas e documentação para operação segura.",
    icon: "shield"
  }
];

export const commissions = [
  {
    id: 1,
    title: "Comissão de segurança (condomínio)",
    description: "Participação em comissões de segurança apoiando decisões com recomendações técnicas, avaliação de soluções e foco em mitigação de riscos.",
    icon: "shield-check"
  },
  {
    id: 2,
    title: "Comissão de segurança do bairro",
    description: "Atuação em comissão de segurança comunitária com olhar técnico para apoiar decisões, melhorias e diálogos com o serviço público.",
    icon: "home"
  },
  {
    id: 3,
    title: "Viabilidade técnica de carregadores para veículos elétricos",
    description: "Participação em comissões de viabilidade técnica para implantação de carregadores de veículos elétricos, elaborando análises e pareceres para fundamentar decisões.",
    icon: "plug-zap"
  }
];

export const cases = [
  {
    id: 1,
    name: "Modernização de CFTV e estratégia de segurança",
    description: "Renovação completa do parque de câmeras com infraestrutura planejada, garantindo cobertura inteligente e operação remota estável.",
    type: "Segurança",
    status: "concluído",
    ctaText: "Segurança / CFTV"
  },
  {
    id: 2,
    name: "Wi-Fi para visitantes com rede isolada + IoT",
    description: "Implementação de Wi-Fi segmentado para visitantes, dispositivos IoT e colaboradores, com isolamento e segurança da rede principal.",
    type: "Tecnologia",
    status: "concluído",
    ctaText: "Conectividade / Wi-Fi"
  },
  {
    id: 3,
    name: "Controle de acesso e biometria",
    description: "Configuração e parametrização de controle de acesso biométrico com políticas de segurança, auditoria e governança.",
    type: "Segurança",
    status: "concluído",
    ctaText: "Controle de acesso"
  },
  {
    id: 4,
    name: "Auditoria e recomendações de segurança",
    description: "Auditoria de processos e tecnologia de segurança com recomendações práticas para mitigação de riscos.",
    type: "Segurança",
    status: "concluído",
    ctaText: "Auditoria / consultoria"
  },
  {
    id: 5,
    name: "Automação e conectividade",
    description: "Projetos de automação residencial e comercial integrando dispositivos inteligentes e melhorando a estabilidade de redes.",
    type: "Automação",
    status: "concluído",
    ctaText: "Automação / IoT"
  },
  {
    id: 6,
    name: "Em andamento: ideias e protótipos",
    description: "Projetos em validação e ideias sendo desenvolvidas para melhorias em conectividade, segurança e automação.",
    type: "Em andamento",
    status: "em-andamento",
    ctaText: "Projetos / ideias"
  }
];

export const services = [
  {
    id: 1,
    title: "Arquitetura de soluções digitais",
    description: "Planejamento de sistemas, plataformas e integrações (APIs, dados e serviços) com foco em eficiência e escala.",
    icon: "layout"
  },
  {
    id: 2,
    title: "Tecnologia & inovação",
    description: "Uso da tecnologia como ferramenta estratégica para resolver problemas reais com clareza e impacto.",
    icon: "lightbulb"
  },
  {
    id: 3,
    title: "Automação e sistemas inteligentes",
    description: "Soluções automatizadas, conectadas e escaláveis com IoT e integrações confiáveis.",
    icon: "cpu"
  },
  {
    id: 4,
    title: "Criação de conteúdo tech",
    description: "Conteúdo educativo sobre tecnologia, conectividade e inovação com foco em utilidade e credibilidade.",
    icon: "video"
  },
  {
    id: 5,
    title: "Conteúdo e educação tecnológica",
    description: "Educação tecnológica clara e acessível para pessoas e equipes que precisam tomar decisões melhores.",
    icon: "book-open"
  },
  {
    id: 6,
    title: "Parcerias e projetos como creator",
    description: "Parcerias, campanhas e ativações de conteúdo com marcas e iniciativas de tecnologia.",
    icon: "megaphone"
  },
  {
    id: 7,
    title: "Consultoria e projetos sob demanda",
    description: "Apoio estratégico e técnico para projetos personalizados em tecnologia, conectividade e segurança.",
    icon: "users"
  }
];

export const testimonials = [
  {
    id: 1,
    text: "Profissional extremamente competente, entrega soluções que realmente funcionam e são fáceis de operar.",
    author: "Cliente corporativo"
  },
  {
    id: 2,
    text: "Clareza na comunicação e domínio técnico impressionante. Facilita decisões estratégicas.",
    author: "Gestor de TI"
  },
  {
    id: 3,
    text: "Transformou nossa operação com automações inteligentes e bem pensadas, com ganho real de eficiência.",
    author: "Diretor de operações"
  }
];

export const socialLinks = {
  instagram: "https://instagram.com/tiagocardoso1",
  linkedin: "https://www.linkedin.com/in/tiagocardoso1",
  youtube: "https://youtube.com/@tiagocardoso1",
  tiktok: "https://www.tiktok.com/@tiago_cardoso1"
};

export const contactInfo = {
  whatsapp: "+5511984845464",
  whatsappMessage: "Olá, Tiago! Quero conversar sobre um projeto de tecnologia.",
  email: "contato@ticardoso.com.br"
};

export const faqData = [
  {
    question: "Você atende fora de São Paulo?",
    answer: "Sim. Estou baseado em São Paulo e atendo projetos em todo o Brasil, presencialmente ou remoto, conforme a necessidade."
  },
  {
    question: "Automação residencial é para quem?",
    answer: "Para empresas, condomínios e residências que querem mais conforto, segurança e eficiência no dia a dia."
  },
  {
    question: "Preciso melhorar o Wi-Fi da minha casa. Como funciona?",
    answer: "Primeiro faço o diagnóstico da rede e do espaço. Nem sempre é preciso comprar equipamentos caros: dá para otimizar recursos, escolher os dispositivos certos, implementar e ensinar a usar."
  },
  {
    question: "Você é parente da Nah Cardoso?",
    answer: "Sim, sou primo da Nah Cardoso."
  },
  {
    question: "Por que contratar um consultor de tecnologia?",
    answer: "Se você não se sente confortável com tecnologia, um consultor ajuda a traduzir o que você precisa, evita compras desnecessárias e garante uma solução que realmente funciona."
  },
  {
    question: "Esse tipo de consultoria é cara?",
    answer: "Muitas vezes o investimento é menor do que parece porque evita retrabalho, reduz custos com equipamentos errados e melhora o resultado final."
  },
  {
    question: "Como funciona o processo de trabalho?",
    answer: "Começamos com diagnóstico e objetivos, seguimos para o desenho da solução e, na sequência, apoio na implementação e acompanhamento."
  },
  {
    question: "Você é Vivo Creator?",
    answer: "Sim. Sou Vivo Creator e produzo conteúdo tech com foco em utilidade, conectividade e inovação."
  },
  {
    question: "Onde encontro seus conteúdos oficiais?",
    answer: "Você pode acessar meus canais em Instagram, LinkedIn, YouTube e TikTok na página /links do site."
  },
  {
    question: "Qual a melhor forma de contato?",
    answer: "Você pode falar comigo pelo WhatsApp, e-mail ou LinkedIn. Encontre os acessos na seção de contato e em /links."
  }
];
